/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

const readInt = (raw: string | undefined, fallback: number, min = 1) => {
  const value = Number(raw);
  if (!Number.isFinite(value) || value < min) return fallback;
  return Math.floor(value);
};

const nodeEnv = String(__APP_NODE_ENV__ || 'development').trim() || 'development';
const customerServiceBaseUrlFallback = nodeEnv === 'production' ? '/kefu' : 'http://localhost:20108';

export const RUNTIME_CONFIG = {
  apiBaseUrl: String(__APP_API_BASE_URL__ || '/api').trim() || '/api',
  customerServiceBaseUrl:
    String(__APP_CUSTOMER_SERVICE_BASE_URL__ || customerServiceBaseUrlFallback).trim() ||
    customerServiceBaseUrlFallback,
  customerServiceUnreadEndpoint: String(__APP_CUSTOMER_SERVICE_UNREAD_ENDPOINT__ || '').trim(),
  customerServiceUnreadCountEnabled:
    String(__APP_CUSTOMER_SERVICE_UNREAD_COUNT_ENABLED__ || '').trim().toLowerCase() === 'true',
  proofUploadMaxRawBytes: readInt(__APP_PROOF_UPLOAD_MAX_RAW_BYTES__, 12 * 1024 * 1024, 1024),
  proofUploadMaxCompressedBytes: readInt(
    __APP_PROOF_UPLOAD_MAX_COMPRESSED_BYTES__,
    2 * 1024 * 1024,
    1024
  ),
  proofUploadMaxImageSide: readInt(__APP_PROOF_UPLOAD_MAX_IMAGE_SIDE__, 1600, 100),
} as const;
